<template>
  <div class="Cooperaprog">
    <!-- banner start -->
    <div class="teamproject-bannerbox">
      <div class="teamproject-bannerbox-small">
        <div class="teamproject-bannerbox-small-img">
          <img src="../assets/teamproject/chuang.png" />
        </div>
        <p>我们有创造的动力，创新的魄力，追求完美，一丝不苟</p>
      </div>
    </div>
    <!-- banner end -->
    <!-- teamproject start -->
    <div class="teamproject" align="center">
      <p class="teampoject-title">合作方案</p>
      <p class="teampoject-title-english">COOPOERATION CASES</p>
      <p class="green-line"></p>
      <el-row>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" v-for="(item, index) in CooperationList" :key='item.index'>
          <div class="teamproject-item">
            <div class="teamproject-item-bigcontent">
              <div class="teamproject-item-image">
                <img :src="item.picture" />
              </div>
              <div class="teamproject-item-image-content">
                <p class="teamproject-title">{{item.title}}</p>
                <p class="team-label">
                  <img src="../assets/teamproject/biaoqian.png" />
                </p>
                <p class="teamproject-contents">{{item.description}}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="team-bnt-box">
      <el-button round class="team-bnt" @click="SelectContact()">了解更多<i class="el-icon-arrow-right"></i></el-button>
    </div>
    <!-- team-bnt-box end -->
    <!-- teamproject end -->
    <!-- 底部引入 -->
    <FooderContent></FooderContent>
  </div>
</template>

<script>
  import FooderContent from '../components/fooder.vue'
  	import {caseslist} from '../../api/index.js'
  	import {url} from '../../config/config.js'
  export default {
    components: {
      FooderContent
    },
    methods:{
      /* 联系我们 */
      SelectContact() {
      	this.$router.push({
      		path: '/Contactus#dwon'
      	})
      }
    },
  	created() {
  		//合作案例
  		caseslist().then(res=>{
  		  res.data.data.map(CooperationList=>{
  		    CooperationList.picture = url + CooperationList.picture
  		  })
  		  this.CooperationList=res.data.data
  		  console.log(this.CooperationList)
  		})
  		.catch(err=>{
  		  alert('错误信息'+err.msg)
  		})
  	},
    data() {
      return {
        teamlist: [],
  		CooperationList:[],
      }
    }
  }
</script>

<style>
  /* banner start */
.teamproject-bannerbox {
	width: 100%;
	height: 42.5rem;
	min-width: 118rem;
	max-width: 100%;
	background-image: url(../assets/teamproject/bannerimg.jpg);
	background-size: 100% 100%;
	position: relative
}

.teamproject-bannerbox-small {
	width: 42rem;
	position: absolute;
	top: 13rem;
	left: 53rem !important;
	font-size: 1.75rem;
	font-family: SourceHanSansSC-Medium;
	color: #fff;
	opacity: .83
}

.teamproject-bannerbox-small-img {
	margin-left: 30rem;
	height: 11.25rem;
	background-size: 100% 100%;
	width: 40%;
	height: 100%
}

.teamproject-bannerbox-small p {
	margin: 0
}

  /* banner end */
  /* teamproject start */
  .teamproject {
  	width: 98%;
  	overflow: auto;
  	margin: 0 auto
  }

  .teampoject-title {
  	font-size: 2.25rem;
  	font-family: SourceHanSansSC-Medium;
  	color: #333;
  	text-align: center;
  	margin-bottom: 1.25rem;
  	margin-top: 4.375rem
  }

  .teampoject-title-english {
  	font-size: 18px;
  	font-family: Source Han Sans SC;
  	color: #999;
  	text-align: center;
  	margin-top: .375rem;
  	margin-bottom: 1.875rem
  }

  .green-line {
  	width: 3.125rem;
  	height: .25rem;
  	background-color: #39ab6d;
  	margin: 0 auto 3.125rem
  }

  .teamproject-item {
  	width: 94%;
  	overflow: auto;
  	margin-bottom: 3.5625rem
  }

  .teamproject-item-bigcontent {
  	margin-top: 3.125rem;
  	float: left !important;
  	width: 95%;
  	overflow: auto;
  	margin-right: 3%;
  	-webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  	background: #fff;
  	opacity: 1
  }

  .teamproject-item-image {
  	overflow: hidden
  }

  .teamproject-item-image img {
  	width: 37%;
  	height: 100%;
  	background-size: 100%
  }

  .teamproject-item-image :hover {
  	cursor: default;
  	-webkit-transform: scale(1.2);
  	transform: scale(1.2);
  	-webkit-transition: all .5s linear;
  	transition: all .5s linear
  }

  .teamproject-item-image-content :hover {
  	-webkit-transform: translateY(-5px);
  	transform: translateY(-5px);
  	-webkit-transition: -webkit-transform .4s;
  	transition: -webkit-transform .4s;
  	transition: transform .4s;
  	transition: transform .4s, -webkit-transform .4s
  }

  .teamproject-title {
  	margin-left: 1.4375rem;
  	margin-bottom: .625rem;
  	margin-top: .625rem
  }

  .team-label {
  	width: .625rem;
  	height: .625rem;
  	margin-top: -.1rem;
  	margin-left: 1.4375rem;
  	float: left
  }

  .team-label img {
  	width: 100%;
  	height: 100%;
  	background-size: 100%
  }

  .teamproject-contents {
  	width: 80%;
  	margin: 0 auto;
  	padding-bottom: 3.125rem;
  	font-size: .5rem;
  	font-family: Source Han Sans SC
  }

  .team-bnt-box {
  	text-align: center
  }

  .team-bnt {
  	z-index: 9999;
  	margin: 3.5625rem auto !important
  }

  @media screen and (max-width: 100rem) {
    .teamproject-bannerbox {
    	width: 100%;
    	height: 35rem;
    	background-image: url(../assets/teamproject/bannerimg.jpg);
    	background-size: 100% 100%
    }

    .teamproject-bannerbox-small {
    	width: 36rem;
    	position: absolute;
    	top: 9rem;
    	left: 60rem !important;
    	font-size: 1.5rem !important;
    	font-family: SourceHanSansSC-Medium;
    	color: #fff;
    	opacity: .83
    }

    .teamproject-bannerbox-small-img {
    	margin-left: 24rem;
    	height: 11.25rem;
    	background-size: 100% 100%;
    	width: 35%;
    	height: 100%
    }

    .teamproject-bannerbox-small-img img {
    	width: 100%;
    	height: 100%
    }

    .teamproject-bannerbox-small p {
    	margin: 0 !important
    }

    .teamproject {
    	width: 98%;
    	min-width: 110rem;
    	max-width: 100%;
    	overflow: auto;
    	margin: 0 auto
    }

    .teamproject .el-row {
    	width: 100%;
    	min-width: 100%
    }

    .team-bnt-box {
    	min-width: 110rem
    }
  }

  @media screen and (max-width: 62rem) {
    .teamproject-bannerbox {
    	width: 100%;
    	min-width: 100%;
    	max-width: 100%;
    	height: 15rem;
    	background-image: url(../assets/teamproject/bannerimg.jpg);
    	background-size: 100% 100%
    }

    .teamproject-bannerbox-small {
    	width: 25rem;
    	position: absolute;
    	top: 4.5rem;
    	left: 29.5rem !important;
    	font-size: .3rem !important;
    	font-family: SourceHanSansSC-Medium;
    	color: #fff;
    	opacity: .83
    }

    .teamproject-bannerbox-small-img {
    	width: 5rem;
    	height: 4rem;
    	background-size: 100% 100%;
    	margin-left: 13rem
    }

    .teamproject-bannerbox-small-img img {
    	width: 100%;
    	height: 100%
    }

    .teamproject-bannerbox-small p {
    	margin: 0 !important
    }

    .teamproject {
    	width: 98%;
    	max-width: 100%;
    	overflow: auto;
    	margin: 0 auto
    }

    .team-bnt-box,
    .teamproject {
    	min-width: 100%
    }
  }

  @media screen and (max-width: 48rem) {
    .teamproject-bannerbox {
    	width: 100%;
    	height: 15rem;
    	background-image: url(../assets/teamproject/bannerimg.jpg);
    	background-size: 100% 100%
    }

    .teamproject-bannerbox-small {
    	width: 87%;
    	min-width: 87%;
    	position: absolute;
    	top: 5.35rem;
    	left: 1.5rem !important;
    	font-size: .75rem !important;
    	font-family: SourceHanSansSC-Medium;
    	color: #fff;
    	opacity: .83
    }

    .teamproject-bannerbox-small-img {
    	width: 3rem;
    	min-width: 3rem;
    	height: 3rem;
    	background-size: 100% 100%;
    	margin-left: 14rem
    }

    .teamproject-bannerbox-small-img img {
    	width: 100%;
    	height: 100%
    }

    .teamproject-bannerbox-small p {
    	margin: 0 !important;
    	width: 16rem
    }

    .teamproject {
    	width: 98%;
    	max-width: 100%;
    	overflow: auto;
    	margin: 0 auto
    }

    .team-bnt-box,
    .teamproject {
    	min-width: 100%
    }
  }

  /* team-bnt-box end */
</style>



// WEBPACK FOOTER //
// src/views/Cooperaprog.vue